import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlCopyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.9 6.85H18.25V3.2C18.25 2.18 17.42 1.35 16.4 1.35H13.85V1C13.85 0.59 13.51 0.25 13.1 0.25H6.49998C6.08998 0.25 5.74998 0.59 5.74998 1V1.35H3.19998C2.17998 1.35 1.34998 2.18 1.34998 3.2V20.8C1.34998 21.82 2.17998 22.65 3.19998 22.65H10.28C10.54 23.29 11.17 23.75 11.9 23.75H20.9C21.86 23.75 22.65 22.96 22.65 22V8.6C22.65 7.64 21.86 6.85 20.9 6.85ZM7.24998 1.75H12.35V3.55H7.24998V1.75ZM2.84998 20.8V3.2C2.84998 3.01 3.00998 2.85 3.19998 2.85H5.74998V4.3C5.74998 4.71 6.08998 5.05 6.49998 5.05H13.1C13.51 5.05 13.85 4.71 13.85 4.3V2.85H16.4C16.59 2.85 16.75 3.01 16.75 3.2V6.85H11.9C10.94 6.85 10.15 7.64 10.15 8.6V21.15H3.19998C3.00998 21.15 2.84998 20.99 2.84998 20.8ZM21.15 22C21.15 22.14 21.04 22.25 20.9 22.25H11.9C11.76 22.25 11.65 22.14 11.65 22V8.6C11.65 8.46 11.76 8.35 11.9 8.35H20.9C21.04 8.35 21.15 8.46 21.15 8.6V22Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlCopyIcon.displayName = 'CtrlCopyIcon';
